import React from "react";
import PropTypes from "prop-types";
import Skeleton from "antd/lib/skeleton";

const SkeletonComponent = ({
  loading,
  avatar,
  children,
  errors,
  errorsStyle,
  onErrorsClick,
  ...skeletonProps
}) => {
  return (
    <Skeleton loading={loading} active avatar={avatar} {...skeletonProps}>
      {children}
    </Skeleton>
  );
};

SkeletonComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  avatar: PropTypes.bool,
  errors: PropTypes.string,
  errorsStyle: PropTypes.object,
  onErrorsClick: PropTypes.func,
  children: PropTypes.node,
};

export default SkeletonComponent;
